<mat-card class="buy-sell-plan-details">
    <mat-card-content>
        <app-approval-status-card [buySellPlanEmployee]="buySellPlanEmployee"></app-approval-status-card>

        <div>
            <div appLocalizationPopupDirective [localizationCode]="'OutstandingHours'" class="label">
                {{ 'OutstandingHours' | translate: {Default: "Outstanding Hours"} }}
            </div>
            <div class="value">{{ employeeTimeOffType?.availableHours }}</div>
        </div>

        <div *ngIf="buySellPlan?.displayFutureAccrual === true && buySellPlanEmployee?.futureAccruals?.length">
            <div appLocalizationPopupDirective [localizationCode]="'FutureAccruals'" class="label">
                {{ 'FutureAccruals' | translate: {Default: "Future Accruals"} }}
            </div>

            <div class="value">
                <ul>
                    <li *ngFor="let accrual of buySellPlanEmployee?.futureAccruals">
                        {{ accrual.date | date:'mediumDate' }}: {{ accrual.amount }}
                    </li>
                </ul>
            </div>
        </div>

        <div>
            <div class="label" appLocalizationPopupDirective [localizationCode]="'HourlyCost'">
                {{ 'HourlyCost' | translate: {Default: "Hourly Cost"} }}
            </div>
            <div class="value">{{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hourlyCost
                }}</div>
        </div>

        <mat-form-field appearance="fill" appLocalizationPopupDirective [localizationCode]="'RequestType'">
            <mat-label>{{ 'RequestType' | translate: {Default: "Type"} }}</mat-label>
            <mat-select [(ngModel)]="selectedType" (selectionChange)="hoursInput = 0">
                <mat-option value="BUY">Buy</mat-option>
                <mat-option value="SELL">Sell</mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="selectedType">
            <div class="label" appLocalizationPopupDirective [localizationCode]="'AvailableHours'">
                {{ 'AvailableHours' | translate: {Default: "Available Hours"} }}
            </div>
            <div class="value">
                {{
                (selectedType === 'BUY'
                ? buySellPlanEmployee?.maximumBuyHours
                : buySellPlanEmployee?.maximumSellHours) || '0'
                }}
            </div>
        </div>

        <mat-form-field appearance="fill" *ngIf="selectedType" appLocalizationPopupDirective [localizationCode]="'NumberOfHours'">
            <mat-label>{{ 'NumberOfHours' | translate: {Default: "Number Of Hours"} }}</mat-label>
            <input matInput type="number"
                [max]="(selectedType === 'BUY' ? buySellPlanEmployee?.maximumBuyHours : buySellPlanEmployee?.maximumSellHours) || 0"
                [min]="0" [(ngModel)]="hoursInput">
        </mat-form-field>

        <div *ngIf="selectedType">
            <div *ngIf="selectedType === 'BUY'" class="label" appLocalizationPopupDirective [localizationCode]="'SalaryDeduction'">
                {{ 'SalaryDeduction' | translate: {Default: "Salary Deduction"} }}
            </div>
            <div *ngIf="selectedType === 'SELL'" class="label" appLocalizationPopupDirective [localizationCode]="'SalaryAddition'">
                {{ 'SalaryAddition' | translate: {Default: "Salary Addition"} }}
            </div>
            <div class="value">{{ compensation?.payRateCurrency?.id | currencyDisplay: hoursInput *
                buySellPlanEmployee?.hourlyCost }}</div>
        </div>
    </mat-card-content>

    <mat-card-actions>
        <button appLocalizationPopupDirective [localizationCode]="'SubmitRequest'" mat-raised-button setColor="primaryColour" color="primary" [disabled]="hoursInput < 1"
            appPreventDoubleClick (throttledClick)="onSubmit()">
            {{ 'SubmitRequest' | translate: {Default: "Submit Request"} }}
        </button>
    </mat-card-actions>
</mat-card>